import { useTranslation } from 'react-i18next'
import classNames from 'classnames'

import { FILE_SCOPE_POST } from '../../../constants/file'
import Button, { BUTTON_HEIGHT_32 } from '../../Button'
import { FilesContentGallery } from '../../FilesContentGallery'
import Text from '../../Text'
import {
  useNewsboardPostFilesEdit,
  useNewsboardPostProfileContext,
} from '../Newsboard.hooks'
import { NewsboardMessageText } from '../NewsboardMessageText'
import { PostBodySkeleton } from '../PostBodySkeleton'

import { NEWSBOARD_POST_PROFILE_EDIT_MESSAGE_BTN_QA_NAME } from './NewsboardPostProfileHeaderContent.constants'
import { useNewsboardPostProfileEditMessage } from './NewsboardPostProfileHeaderContent.hooks'

import * as styles from './NewsboardPostProfileHeaderContent.module.css'

import EditIcon from '../../../icons/edit.svg'
import PlusIcon from '../../../icons/plus.svg'

function NewsboardPostProfileHeaderContent({ isLoading }) {
  const { t } = useTranslation()

  const { handleCloseModal, handleUpdateEntity, postData, setModal } =
    useNewsboardPostProfileContext()

  const { handleOpenModal: handleOpenEditMessageModal } =
    useNewsboardPostProfileEditMessage()

  async function handleUpdateFiles(files) {
    return handleUpdateEntity({ files })
  }

  const { files, galleryEditProps, isGalleryVisible } =
    useNewsboardPostFilesEdit({
      data: postData,
      onCloseModal: handleCloseModal,
      onSetModal: setModal,
      onUpdateFiles: handleUpdateFiles,
    })

  const canEdit = postData?.permissions?.can_edit
  const hasMessage = Boolean(postData?.text)

  return isLoading ? (
    <div className={styles.NewsboardPostProfileHeaderContent}>
      <PostBodySkeleton />
    </div>
  ) : (
    <div className={styles.NewsboardPostProfileHeaderContent}>
      <div className={styles.message}>
        <Text isSecondary>{t('Newsboard.MessageLabelKey')}</Text>
        <div
          className={classNames(styles.messageContent, {
            [styles.editable]: canEdit,
          })}
        >
          {canEdit ? (
            <div className={styles.actions}>
              <Button.Outlined
                isGrey
                beforeIconProps={{ Icon: hasMessage ? EditIcon : PlusIcon }}
                height={BUTTON_HEIGHT_32}
                qaName={NEWSBOARD_POST_PROFILE_EDIT_MESSAGE_BTN_QA_NAME}
                tooltip={t(
                  hasMessage
                    ? 'Profile.EditInfoItemBtnTooltipKey'
                    : 'Profile.AddInfoItemBtnTooltipKey'
                )}
                onClick={handleOpenEditMessageModal}
              />
            </div>
          ) : null}
          {hasMessage ? (
            <NewsboardMessageText messageContent={postData.text} />
          ) : (
            <Text disabled isSecondary>
              {t('Select.NoDataKey')}
            </Text>
          )}
        </div>
      </div>
      {isGalleryVisible ? (
        <FilesContentGallery
          {...galleryEditProps}
          files={files}
          scope={FILE_SCOPE_POST}
        />
      ) : null}
    </div>
  )
}

export default NewsboardPostProfileHeaderContent
